// extracted by mini-css-extract-plugin
module.exports = {"pt-header":"pt-header-ae82470b1cad245bb333415fb414387a"};